import {
  GET_BY_ID_REDIRECT_OK,
  GET_BY_ID_REDIRECT_ERR,
} from "./get-by-id-redirect.action";

const InitState = {
  error: null,
  content: null,
};

export default function GetByIdRedirectReducer(state = InitState, action) {
  switch (action.type) {
    case GET_BY_ID_REDIRECT_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_BY_ID_REDIRECT_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
